import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShopComponent } from './shop/shop.component';
import { UserComponent } from './user/user.component';
import { JobsComponent } from './jobs/jobs.component';
import { ImprintComponent } from './imprint/imprint.component';


const routes: Routes = [
  { path: '', redirectTo: '/shop', pathMatch: 'full' },
  {
    path: 'shop',
    component: ShopComponent,
  },
  {
    path: 'shop/:col1',
    component: ShopComponent,
  },
  {
    path: 'shop/:col1/:col2',
    component: ShopComponent,
  },
  {
    path: 'user',
    component: UserComponent
  },
  {
    path: 'user/:area',
    component: UserComponent
  },
  {
    path: 'jobs',
    component: JobsComponent
  },
  {
    path: 'imprint',
    component: ImprintComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
